import { useReducer } from 'react';

type State<Data> = {
	readonly isOpen: boolean;
	readonly operation: 'CREATE' | 'UPDATE';
	readonly data: Data | null;
};

type OpenCreateAction = {
	readonly type: 'OPEN_CREATE';
};

type OpenEditAction<Data> = {
	readonly type: 'OPEN_UPDATE';
	readonly data: Data;
};

type CloseAction = {
	readonly type: 'CLOSE';
};

type Action<Data> = OpenCreateAction | OpenEditAction<Data> | CloseAction;

type Result<Data> = {
	readonly state: State<Data>;
	readonly openCreate: () => void;
	readonly openUpdate: (data: Data) => void;
	readonly close: () => void;
};

const reducer = <Data>(state: State<Data>, action: Action<Data>): State<Data> => {
	switch (action.type) {
		case 'OPEN_CREATE':
			return {
				...state,
				isOpen: true,
				operation: 'CREATE',
			};

		case 'OPEN_UPDATE':
			return {
				isOpen: true,
				operation: 'UPDATE',
				data: action.data,
			};

		case 'CLOSE':
			return {
				...state,
				isOpen: false,
			};
	}
};

/**
 * @deprecated Use ModalContext instead
 */
const useEditModal = <Data>(): Result<Data> => {
	const [state, dispatch] = useReducer(reducer<Data>, {
		isOpen: false,
		operation: 'CREATE',
		data: null,
	});

	const openCreate = () => {
		dispatch({ type: 'OPEN_CREATE' });
	};

	const openUpdate = (data: Data) => {
		dispatch({ type: 'OPEN_UPDATE', data });
	};
	const close = () => {
		dispatch({ type: 'CLOSE' });
	};

	return {
		state,
		openCreate,
		openUpdate,
		close,
	};
};

export { useEditModal, type State as EditModalState };
